import z from "zod";

export const adminUserSchema = z.object({
  name: z.string().trim().min(1, "É necessário informar o nome!"),
  email: z.string().trim().min(1, "É necessário informar o e-mail!").pipe(z.email("O e-mail deve ser válido")),
  phoneNumber: z.string().trim().optional(),
  role: z.string().min(1, "É necessário selecionar o perfil!"),
  status: z.string().min(1, "É necessário selecionar o status!"),
});

export type AdminUserFormData = z.infer<typeof adminUserSchema>;
